import { ReactElement } from "react";
import { Text } from "@mantine/core";
import { formatQuantity } from "@common/utils/string";
import { AddOnConfirmModal } from "@addons/components/AddOnConfirmModal";

interface Props {
  rowsToErase?: number;
  /** Track ingests into the storage warehouse, so its events go away with it */
  hasProductAnalytics?: boolean;
  onClose(save?: boolean): void;
  opened: boolean;
}

export default function RemoveStorageRentModal({
  opened,
  onClose,
  rowsToErase,
  hasProductAnalytics,
}: Props): ReactElement {
  return (
    <AddOnConfirmModal
      testId="RemoveStorage-modal"
      title="Erase all data?"
      confirmLabel="Delete all data"
      cancelLabel="Keep storage"
      danger
      opened={opened}
      onClose={onClose}
    >
      <Text c="gray.4" fz="sm">
        Once Storage is disabled, all{" "}
        {rowsToErase ? formatQuantity(rowsToErase) : ""} rows of your data will
        be permanently deleted.
        {hasProductAnalytics && " This includes events from Track."} This cannot
        be undone.
      </Text>
    </AddOnConfirmModal>
  );
}
